var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox"},[_c('Checkbox',_vm._b({on:{"change":_vm.update}},'Checkbox',{value: _vm.value},false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }